var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { GetStackTraceStr, Global } from "js-vextensions";
import { RunInAction } from "mobx-graphlink";
import { g } from "../../PrivateExports.js";
import { wvc_store } from "../../Store/WVCStore.js";
import { NotificationMessage } from "./NotificationMessage.js";
import { SendErrorToSentry } from "../../Utils/General/Errors.js";
let ErrorMessage = class ErrorMessage extends NotificationMessage {
    constructor(text, stackTrace, pinnedFor) {
        super(text, pinnedFor);
        this.stackTrace = stackTrace;
    }
};
ErrorMessage = __decorate([
    Global
], ErrorMessage);
export { ErrorMessage };
/** Helper, which tries to add a notification-message to the store, but if that fails, falls back to an alert. (useful, eg. in Start_0.ts) */
export function AddErrorMessage(message, stackTrace, pinnedFor) {
    if (stackTrace == null)
        stackTrace = GetStackTraceStr();
    RunInAction("WVC.PostHandleError", () => {
        var _a;
        try {
            wvc_store.notificationMessages.push(new ErrorMessage(message, stackTrace, pinnedFor));
        }
        catch (ex) {
            g.alertCount_notifications = ((_a = g.alertCount_notifications) !== null && _a !== void 0 ? _a : 0) + 1;
            if (g.alertCount_notifications <= 2) {
                alert(message);
            }
            else {
                console.error(message);
            }
        }
    });
}
G({ AddErrorMessage });
// for things which shouldn't happen (with notification and sentry-capture if it does), but should not cause error/crash
export function AssertNotify(condition, messageOrMessageFunc) {
    if (condition)
        return;
    var message = messageOrMessageFunc instanceof Function ? messageOrMessageFunc() : messageOrMessageFunc;
    //const finalMessage = `Assert failed) ${message}\n\nStackTrace) ${GetStackTraceStr()}`;
    const finalMessage = `Assert[notify] failed: ${message}`;
    console.warn(finalMessage);
    AddErrorMessage(finalMessage, GetStackTraceStr());
    SendErrorToSentry(new Error(finalMessage), {}, { stacktrace: true });
    //Sentry.captureMessage(finalMessage, "warning");
}
//# sourceMappingURL=ErrorMessage.js.map